import React from 'react'
import AboutField from '../components/About/About'

function About() {
  return (
    <div >
      <AboutField />
    </div>
  );
}

export default About